import PazienteEventiList from "./pages/PazienteEventiList.vue";

export default {
    PazienteEventiList,
};
